import { getCurrentInstance } from "vue";

export default () => getCurrentInstance().proxy.$store;
